import React from 'react'
import { useDispatch } from 'react-redux'

import { actionSetSelectedItem } from '../../store/actions'
import DefaultSliderData from '../../libs/default-slider'

import EditSliderComponent from './edit-slider'

const NewSliderComponent = () => {
  const dispatch = useDispatch()
  dispatch(actionSetSelectedItem(DefaultSliderData))

  return (
    <EditSliderComponent/>
  )
}

export default NewSliderComponent
